import { useEffect, useState } from "react";
import {
  Box,
  Button,
  Card,
  CardContent,
  CircularProgress,
  Divider,
  makeStyles,
  Modal,
  Select,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from "@material-ui/core";
import { gpColors } from "../../../constants/colors";
import SideDrawer from "../Drawer";
import { getCookie } from "../../../Functions";
import CryptoAES from "crypto-js/aes";
import CryptoENC from "crypto-js/enc-utf8";
import { MenuItem, OutlinedInput } from "@mui/material";
import AddProductValMOdal from "../AddProductValMOdal";
import DataTable from "react-data-table-component";
import EditIcon from "@material-ui/icons/Edit";
import DeleteIcon from "@material-ui/icons/Delete";
import Cookies from "js-cookie";
import api from "../../Interceptors/axiosInstance";
const useStyles = makeStyles((theme) => ({
  roots: {
    display: "flex",
    height: "auto",
    backgroundColor: "#EAE4E8",
  },
  content: {
    width: "100%",
    height: "100%",
    flexGrow: 1,
    paddingTop: "84px",
    paddingLeft: theme.spacing(3),
    paddingRight: theme.spacing(3),
    paddingBottom: theme.spacing(3),
  },
  title: {
    fontSize: "20px",
    fontWeight: 600,
    paddingBottom: 20,
  },
  root: {
    minHeight: "280px",
    marginTop: "20px",
  },
  activeLink: {
    color: "green",
    cursor: "pointer",
    textDecoration: "none",
    "&:hover": {
      textDecoration: "underline",
    },
  },
  deactiveLink: {
    color: "red",
    cursor: "pointer",
    textDecoration: "none",
    "&:hover": {
      textDecoration: "underline",
    },
  },
  editLink: {
    color: "rgb(23, 94, 170)",
    cursor: "pointer",
    textDecoration: "none",
    fontSize: "0.875rem",
    fontWeight: "bold",
    "&:hover": {
      textDecoration: "underline",
    },
  },
  fieldBox: {
    width: "100%",
    margin: 5,
    [theme.breakpoints.only("xs")]: {
      width: "100%",
    },
    [theme.breakpoints.only("sm")]: {
      width: "100%",
    },
  },
  textFieldStyle: {
    width: "100%",
    height: "40px",
  },
}));

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};

const ManageUsers = () => {
  const classes = useStyles();
  const [userData, setUserData] = useState({});
  const [userList, setUserList] = useState();
  const [token, setToken] = useState();
  const [loader, setLoader] = useState(false);
  const [search, setSearch] = useState("");
  const [refresh, setRefresh] = useState(false);
  const [openEditModal, setOpenEditModal] = useState(false);
  const [validationModal, setValidationModal] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [selectedUserId, setSelectedUserId] = useState(null);
  const [addUserData, setAddUserData] = useState({
    id: "",
    firstName: "",
    lastName: "",
    emailId: "",
    role: "",
    activationStatus: "",
    accessId: "",
    password: "",
  });
  //Getting cookies
  // const sessionUsername = Cookies.get("userName");
      
let sessionToken = null;
let sessionRole = null;
let sessionUsername = null;
  // const sessionCookie = Cookies.get("guradPlus_session");
  const storedSession = sessionStorage.getItem("guradPlus_session");

  if (storedSession) {
  const parsed = JSON.parse(storedSession);
  const data = parsed.sessionData; // 🔹 access nested object
  sessionToken = data?.jwt || null;
  sessionUsername = sessionStorage.getItem("userName");
}

const getLoginInfoData = () => {
  if (sessionToken) {
    setToken(sessionToken);
    setUserData({ username: sessionUsername });
  }
};
  // const getLoginInfoData = () => {
  //   console.log("manage users: getLoginInfoData called");
  //   const sessionData = JSON.parse(sessionCookie);
  //   if (sessionData !== null) {
  //     setToken(sessionData.jwt);
  //     setUserData({ username: sessionUsername });
  //   }
  // };
  // const getLoginInfoData = () => {
  //   const getValue = getCookie("guardPlus_user");
  //   if (getValue !== null) {
  //     const decryptedValue = CryptoAES.decrypt(getValue, "secretKey");
  //     const userVal = JSON.parse(decryptedValue.toString(CryptoENC));
  //     setUserData(userVal);
  //     setToken(userVal.loginInfo.data.jwt);
  //   }
  // };

  const getRoleLabel = (role) => {
    switch (role) {
      case "1":
        return "Admin";
      case "2":
        return "USer";
      default:
        return "";
    }
  };
  const getActivationStatus = (status) => {
    const statusStr = status?.toString();
    switch (statusStr) {
      case "0":
        return "Active";
      case "1":
        return "Deactive";
      default:
        return "";
    }
  };
  const filteredData = userList?.filter((item) => {
    const roleLabel = getRoleLabel(item.role);
    const activationStatus = getActivationStatus(
      item.activationStatus
    ).toLowerCase();
    const searchText = search.toLowerCase();
    // const activationStatus = getActivationStatus(item.activationStatus);
    return (
      item.firstName?.toLowerCase().includes(search.toLowerCase()) ||
      item.lastName?.toLowerCase().includes(search.toLowerCase()) ||
      item.emailId?.toLowerCase().includes(search.toLowerCase()) ||
      roleLabel.toLowerCase().includes(search.toLowerCase()) ||
      activationStatus === searchText
      //  activationStatus.toLowerCase().includes(search.toLowerCase())
    );
  });

  const columns = [
    {
      name: "First Name",
      selector: (row) => row.firstName,
      sortable: true,
      center: true,
    },
    {
      name: "Last Name",
      selector: (row) => row.lastName,
      sortable: true,
      center: true,
    },
    {
      name: "Username",
      selector: (row) => row.emailId,
      sortable: true,
      center: true,
    },
    {
      name: "Role",
      selector: (row) => (row.role === "1" ? "Admin" : "User"),
      sortable: true,
      center: true,
    },
    {
      name: "Status",
      cell: (row) => (
        <span>
          {row.activationStatus === "1" ? "Active" : "Deactive"}
          {/* {row.activationStatus === "1" ? "Active" : "Deactive"} */}
        </span>
      ),
      center: true,
    },
    {
      name: "Action",
      cell: (row) => (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <span
            className={classes.editLink}
            onClick={() => handleEditModal(row)}
          >
            {" "}
            <EditIcon />{" "}
          </span>
          <span style={{ margin: "0 4px", color: "#999" }}>|</span>

          <span
            className={classes.deactiveLink}
            onClick={() => {
              setDeleteModal(true);
              setSelectedUserId(row.id);
            }}
          >
            <DeleteIcon />
          </span>
          <span style={{ margin: "0 4px", color: "#999" }}>|</span>

          <span
            className={
              row.activationStatus === "1"
                ? classes.deactiveLink
                : classes.activeLink
            }
            style={{ cursor: "pointer" }}
            onClick={() =>
              handleStatusChange(row.id, row.activationStatus === "1" ? 0 : 1)
            }
          >
            {row.activationStatus === "1" ? "Deactivate" : "Activate"}
          </span>
        </div>
      ),
      center: true,
    },
  ];

  const handleEditModal = (item) => {
    setOpenEditModal(true);
    setUserData(item);
    // setAddUserData(item);
    setAddUserData({
      id: item.id,
      firstName: item.firstName || "",
      lastName: item.lastName || "",
      emailId: item.emailId || "",
      role: item.role || "",
      accessId: item.accessId || "",
      password: item.password || "",
    });
  };
  const handleEditClose = () => setOpenEditModal(false);
  const handleDeleteclose = () => setDeleteModal(false);

  const handleUserData = (e) => {
    let value = e.target.value;
    let name = e.target.name;
    setAddUserData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
    getLoginInfoData();
  }, []);

  useEffect(() => {
    if (token) {
      console.log("Token set in useEffect: ", token);
      getUserList();
    }
    console.log("token not found", token);
    setRefresh(false);
  }, [token, refresh]);

  const getUserList = async () => {
    setLoader(true);
    try {
      // const resp = await fetch(
      //   `${process.env.REACT_APP_API_ENDPOINT}/getAllUsers`,
      //   {
      //     method: "GET",
      //     headers: {
      //       // "ngrok-skip-browser-warning": "true",
      //       Authorization: `Token ${token}`,
      //     },
      //   }
      // );
      const resp = await api.get(`/getAllUsers`);
      console.log("manager usr get all: ", resp);
      const data = await resp.data;
      setUserList(data);
      setLoader(false);
    } catch (e) {
      console.log("User List Error--------------", e);
      setLoader(false);
    }
  };
  const [alert, setAlert] = useState({
    alertStatus: false,
    alertMessage: "",
    alertColor: "",
  });
  function openValidationModal() {
    setValidationModal(true);
  }
  function closeValidationModal() {
    setValidationModal(false);
  }
  const handleDeleteUser = async () => {
    console.log("Selected User ID :- ", selectedUserId);
    setLoader(true);
    try {
      // const resp = await fetch(
      //   `${process.env.REACT_APP_API_ENDPOINT}/deleteUserById`,
      //   {
      //     method: "POST",
      //     body: JSON.stringify({
      //       id: selectedUserId,
      //     }),
      //     headers: {
      //       Authorization: `Token ${token}`,
      //       "Content-Type": "application/json",
      //     },
      //   }
      // );
      const resp = await api.post(`/deleteUserById`, { id: selectedUserId });
      const data = await resp.data;
      setLoader(false);
      if (data.result === "Success") {
        getUserList();
        setDeleteModal(false);
        setAlert({
          ...alert,
          alertStatus: true,
          alertColor: "green",
          alertMessage: "User has been deleted successfully!!",
        });
      } else {
        setDeleteModal(false);
        setAlert({
          ...alert,
          alertStatus: true,
          alertColor: "red",
          alertMessage: "Something went wrong please try again.",
        });
      }
    } catch (e) {
      setLoader(false);
      setAlert({
        ...alert,
        alertStatus: true,
        alertColor: "red",
        alertMessage: "Something went wrong please try after some time.",
      });
    }
  };

  const saveUserData = async () => {
    const anyFieldEmpty = Object.values(addUserData).some(
      (value) => value === ""
    );
    if (anyFieldEmpty) {
      openValidationModal();
      return;
    }
    setLoader(true);
    try {
      // const resp = await fetch(
      //   `${process.env.REACT_APP_API_ENDPOINT}/updateUserData`,
      //   {
      //     method: "POST",
      //     body: JSON.stringify({
      //       id: addUserData.id,
      //       firstName: addUserData.firstName,
      //       lastName: addUserData.lastName,
      //       emailId: addUserData.emailId,
      //       accessId: addUserData.accessId,
      //       password: addUserData.password,
      //     }),
      //     headers: {
      //       Authorization: `Token ${token}`,
      //       "Content-Type": "application/json",
      //     },
      //   }
      // );
      const resp = await api.post("/updateUserData", {
        id: addUserData.id,
        firstName: addUserData.firstName,
        lastName: addUserData.lastName,
        emailId: addUserData.emailId,
        accessId: addUserData.accessId,
        password: addUserData.password,
      });
      const data = await resp.data;
      setLoader(false);
      if (data.result === "Success") {
        getUserList();
        setOpenEditModal(false);
        setAddUserData({
          id: "",
          firstName: "",
          lastName: "",
          emailId: "",
          role: "",
          accessId: "",
        });
        setAlert({
          ...alert,
          alertStatus: true,
          alertColor: "green",
          alertMessage: "User has been updated successfully!!",
        });
        // setUserList(addUserData);
        // console.log("User List After Update :- ", userList);
      } else {
        setOpenEditModal(false);
        setAlert({
          ...alert,
          alertStatus: true,
          alertColor: "red",
          alertMessage: "Something went wrong please try again.",
        });
      }
    } catch (e) {
      setLoader(false);
      setAlert({
        ...alert,
        alertStatus: true,
        alertColor: "red",
        alertMessage: "Something went wrong please try after some time.",
      });
    }
  };
  const handleAlertClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setAlert({
      ...alert,
      alertStatus: false,
      alertColor: "",
      alertMessage: "",
    });
  };

  const handleStatusChange = async (userId, status) => {
    console.log("handle status change: ", userId, status);
    try {
      // const resp = await fetch(
      //   `${process.env.REACT_APP_API_ENDPOINT}/changeStatusByUserId`,
      //   {
      //     method: "POST",
      //     body: JSON.stringify({
      //       id: userId,
      //       activationStatus: status,
      //     }),
      //     headers: {
      //       // "ngrok-skip-browser-warning": "true",
      //       Authorization: `Token ${userData.loginInfo.data.jwt}`,
      //       "Content-Type": "application/json",
      //     },
      //   }
      // );
            const resp = await api.post(`/changeStatusByUserId`, { id: userId, activationStatus: status });

      const data = await resp.data;
      if (data.result === "Success") {
        setRefresh(true);
      }
    } catch (e) {}
  };

  return (
    <Box className={classes.roots}>
      <SideDrawer tabName="manageUsers"  />
      <main className={classes.content}>
        <Typography className={classes.title}>Manage Users</Typography>
        <Divider />
        <Card className={classes.root}>
          <CardContent>
            <div style={{ padding: "20px" }}>
              <Box
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "flex-end",
                  alignItems: "center",
                }}
              >
                <input
                  type="text"
                  placeholder="Search..."
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                  style={{
                    marginBottom: "10px",
                    padding: "10px",
                    width: "300px",
                    border: "1px solid #ccc",
                    borderRadius: "4px",
                  }}
                />
              </Box>
              {/* Data Table */}
              <Box sx={{ borderRadius: 2, overflow: "hidden" }}>
                <DataTable
                  columns={columns}
                  data={filteredData || []}
                  progressPending={loader}
                  progressComponent={
                    <CircularProgress size={30} color="inherit" />
                  }
                  noDataComponent={
                    <div style={{ color: "red" }}>Data Not Exist</div>
                  }
                  pagination
                  paginationPerPage={5}
                  paginationRowsPerPageOptions={[5, 10, 20, 50]}
                  highlightOnHover
                  striped
                  persistTableHead
                  responsive
                  customStyles={{
                    headCells: {
                      style: {
                        backgroundColor: gpColors.logoGray,
                        color: "#fff",
                        fontWeight: "bold",
                        justifyContent: "center",
                      },
                    },
                    rows: {
                      style: {
                        fontSize: "0.875rem",
                      },
                    },
                  }}
                />
              </Box>
            </div>
          </CardContent>
        </Card>
      </main>

      {/* Edit Modal */}
      <Modal
        open={openEditModal}
        onClose={handleEditClose}
        aria-labelledby="modal-title"
        aria-describedby="modal-description"
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 400,
            bgcolor: "background.paper",
            borderRadius: 10,
            boxShadow: 24,
            p: 4,
          }}
        >
          <Box display="flex" flexWrap="wrap">
            <Typography
              variant="h6"
              component="h2"
              style={{
                fontWeight: "bold",
                marginBottom: "20px",
                width: "100%",
              }}
            >
              Edit User
            </Typography>
            <Box className={classes.fieldBox}>
              <Typography>
                First Name<label style={{ color: "red" }}>*</label>
              </Typography>
              <TextField
                variant="outlined"
                size="small"
                className={classes.textFieldStyle}
                name="firstName"
                value={addUserData.firstName}
                onChange={(e) => handleUserData(e)}
              />
            </Box>
            <Box className={classes.fieldBox}>
              <Typography>
                Last Name<label style={{ color: "red" }}>*</label>
              </Typography>
              <TextField
                variant="outlined"
                size="small"
                className={classes.textFieldStyle}
                name="lastName"
                value={addUserData.lastName}
                onChange={(e) => handleUserData(e)}
              />
            </Box>
            <Box className={classes.fieldBox}>
              <Typography>
                Username<label style={{ color: "red" }}>*</label>
              </Typography>
              <TextField
                variant="outlined"
                size="small"
                className={classes.textFieldStyle}
                name="emailId"
                value={addUserData.emailId}
                onChange={(e) => handleUserData(e)}
              />
            </Box>
            <Box className={classes.fieldBox}>
              <Typography>
                Password<label style={{ color: "red" }}>*</label>
              </Typography>
              <TextField
                variant="outlined"
                size="small"
                type="password"
                className={classes.textFieldStyle}
                name="password"
                placeholder="••••••••"
                // value={addUserData.password}
                onChange={(e) => handleUserData(e)}
              />
            </Box>
            <Box className={classes.fieldBox}>
              <Typography>
                Role<label style={{ color: "red" }}>*</label>
              </Typography>
              <Select
                className={classes.textFieldStyle}
                variant="outlined"
                name="role"
                value={addUserData.role}
                onChange={(e) => handleUserData(e)}
                input={<OutlinedInput />}
                disabled
              >
                <MenuItem value="1">Admin</MenuItem>
                <MenuItem value="2">User</MenuItem>
              </Select>
            </Box>
            <Box className={classes.fieldBox}>
              <Typography>
                Access<label style={{ color: "red" }}>*</label>
              </Typography>
              <Select
                className={classes.textFieldStyle}
                variant="outlined"
                name="accessId"
                value={addUserData.accessId}
                onChange={(e) => handleUserData(e)}
                input={<OutlinedInput />}
              >
                <MenuItem value="1">Inward Scan</MenuItem>
                <MenuItem value="2">Outward Scan</MenuItem>
                <MenuItem value="3">Both</MenuItem>
              </Select>
            </Box>
          </Box>
          <Box display="flex" justifyContent="center" mt={4}>
            <Button
              onClick={saveUserData}
              style={{
                backgroundColor: "#F22F46",
                color: "#fff",
                width: "70%",
              }}
            >
              Update
            </Button>
          </Box>
        </Box>
      </Modal>

      {/* delete pop up */}
      <Modal
        open={deleteModal}
        onClose={handleDeleteclose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Typography id="modal-modal-description" sx={{ mt: 2 }}>
            Are you sure you want to delete this user?
          </Typography>
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              mt: 4,
              gap: "20px",
            }}
          >
            <Button
              variant="contained"
              color="default"
              className="dragDialogBtn"
              onClick={handleDeleteclose}
            >
              Cancel
            </Button>
            {/* <Button variant='contained' color='error'  onClick={handleDeleteUser}>Delete</Button> */}
            <Button
              variant="contained"
              color="secondary"
              onClick={handleDeleteUser}
            >
              Delete{" "}
            </Button>
          </Box>
        </Box>
      </Modal>

      <AddProductValMOdal
        validationModal={validationModal}
        closeValidationModal={closeValidationModal}
        handleAlertClose={handleAlertClose}
        alert={alert}
      />
    </Box>
  );
};
export default ManageUsers;
